export const preMakingContent = {
  title: '事前調理',
  detailTitle: '事前調理テンプレート詳細',
  stationSelectPlaceholder: 'ステーションを選択...',
  weeklyTemplatesTitle: '曜日設定のテンプレート',
  customTemplatesTitle: 'カスタム設定のテンプレート',
  loadingMessage: 'テンプレート読み込み中...',
  noWeeklyTemplates: '曜日設定のテンプレートがありません。',
  noCustomTemplates: 'カスタム設定のテンプレートがありません。',
  detailButtonTitle: '詳細',
  applyPreviousDayOrdersButtonTitle: '前日杯数適用',
}

export const preMakingTemplateTableHeaders = ['ID', '名前', '説明', '']
export const preMakingWeeklyTemplateTableHeaders = ['ID', '名前', '説明', 'アクティブ', '']
